@if (hasDisplayConfiguration) {
  <div [class]="globalStyleClass" data-cy="pnc-detail-solution">
    @if (showInViewMode) {
      <div class="pnc-detail-body-output-field-label detail">
        <span data-cy="pnc-detail-solution-label-old-part-number">Old part number</span>
      </div>
      <div class="pnc-detail-body-output-field-value detail"
      data-cy="pnc-detail-solution-old-part-number">{{$safeNavigationMigration(configuration?.data.oldPartNumber) | prettyPrintMaterialNumber | undefinedValue}}</div>
    }
    <div class="pnc-solution-new-part-number-container"
      data-cy="pnc-solution-new-part-number-container">
      <div class="pnc-new-part-number-container ai-solution"
        data-cy="pnc-new-part-number-ai-solution"
        [ngClass]="containerTypeClass">
        <app-input-dropdown #materialInput
          (inputValueChange)="materialChange($event)"
          [initialValue]="$safeNavigationMigration(configuration?.data?.newPartNumber?.material)"
          [inputFormatter]="materialInputFormatter"
          [invertedColor]="showInViewMode"
          [labelInformation]="copyButton"
          [messages]="materialMessages"
          [resultFormatter]="materialInputFormatter"
          [resultsFunction]="searchMaterials"
          [showViewMode]="showInViewMode"
          [validators]="validators.material"
          [warningLevel]="warningLevel($safeNavigationMigration(configuration.displayConfiguration?.materialInput.required))"
          [staticSectionText]=state.oldPartNumberMaterialPrefix
          [showMessagesWhenDisabled]="true"
          baseCypressTag="{{newPartNumberCypressTag}}"
          label="{{newPartNumberAiLabel}}"
        placeholder="{{newPartNumberAiPlaceholder}}"></app-input-dropdown>
        <app-input-text #quantityInput
          (inputValueChange)="quantityChange($event)"
          [initialValue]="quantityInitialValuePipe($safeNavigationMigration(configuration?.data?.newPartNumber?.quantity))"
          [invertedColor]="showInViewMode"
          [messages]="quantityMessages"
          [showViewMode]="showInViewMode"
          [validators]="validators.quantity"
          [warningLevel]="warningLevel($safeNavigationMigration(configuration.displayConfiguration?.quantityInput.required))"
          maxLength="6"
          baseCypressTag="{{quantityCypressTag}}"
          label="{{quantityLabel}}"
        placeholder="{{quantityPlaceholder}}"></app-input-text>
      </div>
      <div class="pnc-solution-additional-information"
        data-cy="pnc-detail-solution-additional-information">
        <app-input-textarea (inputValueChange)="setAdditionalInformation($event)"
                                [initialValue]="initialValuePipe(configuration?.displayConfiguration.additionalInformation.displayMode,
        $safeNavigationMigration(configuration?.data?.additionalInformation))"
          [invertedColor]="showInViewMode"
          [showViewMode]="showInViewMode"
          [warningLevel]="warningLevel($safeNavigationMigration(configuration?.displayConfiguration?.additionalInformation.required))"
          height="88"
          maxLength="400"
          baseCypressTag="{{additionalInfoCypressTag}}"
          label="{{additionalInfoLabel}}"
        placeholder="{{additionalInfoPlaceholder}}"></app-input-textarea>
      </div>
    </div>
    @if (showInViewMode) {
      <div class="pnc-detail-body-output-field-label detail">
        <span data-cy="pnc-detail-solution-solved-by">Solved by</span>
      </div>
      <div class="pnc-detail-body-output-field-value pnc-detail-body-output-field-value-email detail"
      data-cy="pnc-detail-solution-solved-by-email">{{$safeNavigationMigration(configuration?.data.solvedBy) | prettyPrintUpdatedBy | undefinedValue}}</div>
    }
  </div>
}

<ng-template #copyButton>
  @if (showInViewMode) {
    <div>
      <app-tooltip [dynamic]="false" message="Copy part number to clipboard">
        <button (click)="copyMaterialNumber()"
          class="copy-button btn-text-link dark-background"
          data-cy="new-part-number-copy-button">
          <span class="iwp-icon-gen_copy" data-cy="new-part-number-copy-button-icon"></span>
          <span class="text" data-cy="new-part-number-copy-button-text">Copy</span>
        </button>
      </app-tooltip>
    </div>
  }
</ng-template>